export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  
  let browser = 'Unknown';
  if (userAgent.includes('Chrome')) browser = 'Chrome';
  else if (userAgent.includes('Safari')) browser = 'Safari';
  else if (userAgent.includes('Firefox')) browser = 'Firefox';
  else if (userAgent.includes('Edge')) browser = 'Edge';
  
  let device = 'Desktop';
  let deviceManufacturer = '';
  let deviceModel = '';
  
  if (/Mobile|Android|iPhone|iPad|iPod/.test(userAgent)) {
    device = 'Mobile';
  } else if (/Tablet|iPad/.test(userAgent)) {
    device = 'Tablet';
  }
  
  // Extract manufacturer and model for mobile/tablet devices
  if (device === 'Mobile' || device === 'Tablet') {
    // Samsung devices
    if (/Samsung/i.test(userAgent)) {
      deviceManufacturer = 'Samsung';
      const samsungMatch = userAgent.match(/SM-([A-Z0-9]+)/i);
      if (samsungMatch) {
        deviceModel = samsungMatch[1];
      } else {
        const modelMatch = userAgent.match(/Samsung[- ]([A-Z0-9 ]+)/i);
        if (modelMatch) {
          deviceModel = modelMatch[1].trim();
        }
      }
    }
    // Apple devices
    else if (/iPhone/i.test(userAgent)) {
      deviceManufacturer = 'Apple';
      deviceModel = 'iPhone';
      // Try to extract iPhone model
      const iphoneMatch = userAgent.match(/iPhone OS ([0-9_]+)/i);
      if (iphoneMatch) {
        deviceModel = `iPhone (iOS ${iphoneMatch[1].replace(/_/g, '.')})`;
      }
    } else if (/iPad/i.test(userAgent)) {
      deviceManufacturer = 'Apple';
      deviceModel = 'iPad';
      const ipadMatch = userAgent.match(/CPU OS ([0-9_]+)/i);
      if (ipadMatch) {
        deviceModel = `iPad (iOS ${ipadMatch[1].replace(/_/g, '.')})`;
      }
    }
    // Xiaomi devices
    else if (/Xiaomi|Mi |Redmi/i.test(userAgent)) {
      deviceManufacturer = 'Xiaomi';
      const xiaomiMatch = userAgent.match(/(Mi|Redmi|POCO) ([A-Z0-9 ]+)/i);
      if (xiaomiMatch) {
        deviceModel = `${xiaomiMatch[1]} ${xiaomiMatch[2]}`.trim();
      }
    }
    // Oppo devices
    else if (/OPPO/i.test(userAgent)) {
      deviceManufacturer = 'Oppo';
      const oppoMatch = userAgent.match(/OPPO ([A-Z0-9]+)/i);
      if (oppoMatch) {
        deviceModel = oppoMatch[1];
      }
    }
    // Vivo devices
    else if (/vivo/i.test(userAgent)) {
      deviceManufacturer = 'Vivo';
      const vivoMatch = userAgent.match(/vivo ([A-Z0-9]+)/i);
      if (vivoMatch) {
        deviceModel = vivoMatch[1];
      }
    }
    // OnePlus devices
    else if (/OnePlus/i.test(userAgent)) {
      deviceManufacturer = 'OnePlus';
      const oneplusMatch = userAgent.match(/OnePlus ([A-Z0-9]+)/i);
      if (oneplusMatch) {
        deviceModel = oneplusMatch[1];
      }
    }
    // Realme devices
    else if (/Realme/i.test(userAgent)) {
      deviceManufacturer = 'Realme';
      const realmeMatch = userAgent.match(/Realme ([A-Z0-9 ]+)/i);
      if (realmeMatch) {
        deviceModel = realmeMatch[1].trim();
      }
    }
    // Huawei devices
    else if (/Huawei|HUAWEI/i.test(userAgent)) {
      deviceManufacturer = 'Huawei';
      const huaweiMatch = userAgent.match(/([A-Z]{3}-[A-Z0-9]+)/i);
      if (huaweiMatch) {
        deviceModel = huaweiMatch[1];
      }
    }
    // Google Pixel devices
    else if (/Pixel/i.test(userAgent)) {
      deviceManufacturer = 'Google';
      const pixelMatch = userAgent.match(/Pixel ([A-Z0-9 ]+)/i);
      if (pixelMatch) {
        deviceModel = `Pixel ${pixelMatch[1]}`.trim();
      }
    }
    // Motorola devices
    else if (/Motorola|Moto/i.test(userAgent)) {
      deviceManufacturer = 'Motorola';
      const motoMatch = userAgent.match(/Moto ([A-Z0-9 ]+)/i);
      if (motoMatch) {
        deviceModel = `Moto ${motoMatch[1]}`.trim();
      }
    }
    // Nokia devices
    else if (/Nokia/i.test(userAgent)) {
      deviceManufacturer = 'Nokia';
      const nokiaMatch = userAgent.match(/Nokia ([A-Z0-9.]+)/i);
      if (nokiaMatch) {
        deviceModel = nokiaMatch[1];
      }
    }
    // LG devices
    else if (/LG/i.test(userAgent)) {
      deviceManufacturer = 'LG';
      const lgMatch = userAgent.match(/LG-([A-Z0-9]+)/i);
      if (lgMatch) {
        deviceModel = lgMatch[1];
      }
    }
    // Sony devices
    else if (/Sony/i.test(userAgent)) {
      deviceManufacturer = 'Sony';
      const sonyMatch = userAgent.match(/([A-Z0-9]+) Build/i);
      if (sonyMatch) {
        deviceModel = sonyMatch[1];
      }
    }
    // Generic Android
    else if (/Android/i.test(userAgent)) {
      deviceManufacturer = 'Android';
      const androidMatch = userAgent.match(/Android ([0-9.]+)/i);
      if (androidMatch) {
        deviceModel = `v${androidMatch[1]}`;
      }
    }
  }
  
  return { 
    browser, 
    device,
    deviceManufacturer,
    deviceModel
  };
};

export const getIPAddress = async (): Promise<string> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch {
    return 'Unknown';
  }
};